export default {
    methods: {
        collapseByDefault() {
            const screenwidth = screen.width
            const shouldBeCollapsedByDefault = screen.width < 800 || false
            console.log(`Screen Width ${screenwidth} < 800? : ${shouldBeCollapsedByDefault}`)
            return shouldBeCollapsedByDefault
        }
    },
}